import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.Title',
    defaultMessage: 'Smart Notifications Overview'
  },

  titleSubText: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.TitleSubText',
    defaultMessage: 'Includes total smart notifications sent by your notification based apps'
  },

  totalSentLabel: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.TotalSends.Label',
    defaultMessage: 'TOTAL SENT'
  },

  viewedNotificationsLabel: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.ViewedNotifications.Label',
    defaultMessage: 'VIEWED NOTIFICATIONS'
  },

  detailViewsLabel: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.DetailViews.Label',
    defaultMessage: 'DETAIL VIEWS'
  },

  usageByAppLabel: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.UsageByApp.Label',
    defaultMessage: 'USAGE BY APP'
  },

  hoverToViewDetailsLabel: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.HoverToViewDetails.Label',
    defaultMessage: 'Hover to view details'
  },

  uniqueClicksLabel: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.UniqueClicks.Label',
    defaultMessage: 'UNIQUE CLICKS'
  },

  totalViewedLabel: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.TotalViewed.Label',
    defaultMessage: 'TOTAL VIEWED'
  },

  totalDetailsViewedLabel: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.TotalDetailsViewed.Label',
    defaultMessage: 'TOTAL DETAILS VIEWED'
  },

  totalClicksLabel: {
    id: 'SpaceAnalyticsPage.Section.IntegrationsSection.TotalClicks.Label',
    defaultMessage: 'TOTAL CLICKS'
  }
})
